import { useMemo } from "react";
import { EXPERIENCE_STATES } from "constants/experiences";

export const useTripSearchLogic = ({
  trips,
  searchQuery,
  selectedTrip,
  debouncedSearchQuery,
}) => {

  const query = debouncedSearchQuery || '';
  const categorizedTrips = useMemo(() => {
    const tripsArray = trips || [];
    return {
      publishedTrips: tripsArray.filter(t => t.status === EXPERIENCE_STATES.published),
      drafts: tripsArray.filter(t => t.status === EXPERIENCE_STATES.draft),
      deactivatedTrips: tripsArray.filter(t => t.status === EXPERIENCE_STATES.deactivated)
    };
  }, [trips]);
  
  const categorizedSearchResults = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return { publishedTrips: [], drafts: [], deactivatedTrips: [] };
    
    const published = categorizedTrips?.publishedTrips || [];
    const drafts = categorizedTrips?.drafts || [];
    const deactivated = categorizedTrips?.deactivatedTrips || [];
    
    return {
      publishedTrips: published.filter(t => t?.title?.toLowerCase().includes(q)),
      drafts: drafts.filter(t => t?.title?.toLowerCase().includes(q)),
      deactivatedTrips: deactivated.filter(t => t?.title?.toLowerCase().includes(q)),
    };
  }, [query, categorizedTrips]);

  const filteredTrips = useMemo(() => {
    if (selectedTrip) {
      return {
        publishedTrips: selectedTrip.status === EXPERIENCE_STATES.published ? [selectedTrip] : [],
        drafts: selectedTrip.status === EXPERIENCE_STATES.draft ? [selectedTrip] : [],
        deactivatedTrips: selectedTrip.status === EXPERIENCE_STATES.deactivated ? [selectedTrip] : [],
      };
    }
    if (query.trim()) return categorizedSearchResults;
    return categorizedTrips || { publishedTrips: [], drafts: [], deactivatedTrips: [] };
  }, [selectedTrip, query, categorizedSearchResults, categorizedTrips]);

  return {
    debouncedSearchQuery: query,
    categorizedTrips,
    categorizedSearchResults,
    filteredTrips
  };
}; 